/**
 * API Types
 * Type definitions for API requests and responses
 */

export class ApiError extends Error {
  status: number;
  code?: string;
  backendReason?: string;
  payload?: Record<string, unknown>;

  constructor(
    message: string,
    status: number,
    code?: string,
    backendReason?: string,
    payload?: Record<string, unknown>,
  ) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
    this.code = code;
    this.backendReason = backendReason;
    this.payload = payload;
  }
}

export interface RequestConfig {
  method?: 'GET' | 'POST' | 'PUT' | 'DELETE' | 'PATCH';
  body?: any;
  headers?: Record<string, string>;
  requiresAuth?: boolean;
  marchYaknessSessionUuid?: string;
  signal?: AbortSignal;
  /** When true, errors are not reported to Sentry and console.error is suppressed */
  silent?: boolean;
}

// Declare window interface for TypeScript
declare global {
  interface Window {
    APP_AUTH_TOKEN?: string;
    APP_USER_ID?: string;
  }
}
